import {EventEmitter} from "@angular/core";
import { returnEmpty } from "@core/_utils/tools.utils";

export class HeaderSupervBase {
    id: number;
    name: string;
    label: string;
    desc: string;
    visibility: any;
    listVisibility: any[];
    userListUsed: string[] = [];
    groupListUsed: string[] = [];
    basketListUsed: string[] = [];

    notifyParent: EventEmitter<any> = new EventEmitter();

    public Clear() {
        this.id = 0;
        this.name = '';
        this.label = '';
        this.desc = '';
        this.visibility = 0;
        this.listVisibility = [];
        this.userListUsed = [];
        this.groupListUsed = [];
        this.basketListUsed = [];
    }

    public load(adata){
        this.id = adata.id;
        this.name = adata.name;
        this.label = adata.label;
        this.desc = adata.description;
        this.visibility = adata.visibility;
        this.groupListUsed = this.getListUsrGrp(adata.grouplist);
        this.userListUsed = this.getListUsrGrp(adata.userlist);
        this.basketListUsed = this.getListUsrGrp(adata.bsklist);
        this.notifyParent.emit();
    }

    private getListUsrGrp(aData) {
        let wList = '';
        if (Array.isArray(aData)) {
            return [];
        } else {
            wList = returnEmpty(aData);
            if (wList !== '') {
                wList = this.prepareSplit(wList);
                return wList.split(';');
            } else {
                return [];
            }        
        }
    }

    private prepareSplit(aValue) {       
        let wValue = aValue;        
        if (wValue.charAt(0) === ';') {
            wValue = wValue.substring(1);
        }
        if (wValue.charAt(wValue.length - 1) === ';') {
            wValue = wValue.substring(0, wValue.length - 1);
        }
        return wValue;
    }
}
